import delExtraSpaces from './delExtraSpaces';

export default function formatNamePart(str: string | undefined): string {
  return delExtraSpaces(str || '');
}
